import axios from "axios";
import { getOrWaitForPageSession } from "../../network/service";

const API_HOST = process.env.REACT_APP_API_SERVER_HOST || "";

const onboardingHeaders = () => ({
  "access-token": localStorage.getItem("access-token"),
  pubid: localStorage.getItem("pub_id"),
  role_id: localStorage.getItem("role_id"),
});

const api = axios.create({ baseURL: API_HOST });

api.interceptors.request.use(async (axiosConfig) => {
  const isAuthRoute = axiosConfig.url && (axiosConfig.url.includes("/auth/") || axiosConfig.url.includes("/confirm-link"));
  if (!isAuthRoute) {
    try {
      const token = await getOrWaitForPageSession();
      axiosConfig.headers["x-page-session"] = token;
    } catch (e) {
      console.warn("Page session unavailable:", e.message);
    }
  }
  return axiosConfig;
});

export const getOnboardingKeys = () =>
  api.get("/onboarding/keys", { headers: onboardingHeaders() }).then((r) => r.data);

export const getOnboardingValues = () =>
  api.get("/onboarding/values", { headers: onboardingHeaders() }).then((r) => r.data);

export const saveOnboardingValue = (key, payload) =>
  api.put(`/onboarding/values/${key}`, payload, { headers: onboardingHeaders() }).then((r) => r.data);

export const uploadOnboardingValueFile = (key, fileOrFiles) => {
  const fd = new FormData();
  const files = Array.isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles];
  files.filter(Boolean).forEach((file) => fd.append("file", file));
  return api
    .post(`/onboarding/values/${key}/upload`, fd, {
      headers: { ...onboardingHeaders(), "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const deleteOnboardingValue = (key) =>
  api.delete(`/onboarding/values/${key}`, { headers: onboardingHeaders() }).then((r) => r.data);

export const deleteOnboardingValueFile = (key, valueId) =>
  api.delete(`/onboarding/values/${key}/${valueId}`, { headers: onboardingHeaders() }).then((r) => r.data);


export const getOnboardingThemes = () =>
  api.get("/onboarding/keys/themes", { headers: onboardingHeaders() }).then((r) => r.data);

export const getTimezones = () =>
  api.get("/onboarding/config/timezones", { headers: onboardingHeaders() }).then((r) => r.data);

export const checkEmail = (email) =>
  api.get(`/onboarding/auth/check-email?email=${encodeURIComponent(email)}`, { headers: onboardingHeaders() }).then((r) => r.data);

export const getSubscriptionPlans = () =>
  api.get("/onboarding/plans", { headers: onboardingHeaders() }).then((r) => r.data);

export const getThemeCatalog = () =>
  api.get("/onboarding/keys/themes", { headers: onboardingHeaders() }).then((r) => r.data);

export const publishOnboarding = () =>
  api.post("/onboarding/publish", null, { headers: onboardingHeaders() }).then((r) => r.data);

export const publishInitial = () =>
  api.post("/onboarding/publish/initial", null, { headers: onboardingHeaders() }).then((r) => r.data);

export const getOnboardingStatus = () =>
  api.get("/onboarding/status", { headers: onboardingHeaders() }).then((r) => r.data);

export const confirmPublisherOnboarding = (pubid) =>
  api.get(`/onboarding/publish/confirm-link?pubid=${pubid}`).then((r) => r.data);
